import type { FunctionComponent } from 'react';
import { useEffect, useRef, useState } from 'react';

import type { IHistoryGame } from '../../../api/fetchers/history/types';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useHeaderSlice } from '../../../store/slices/header/selectors';
import { headerActions } from '../../../store/slices/header/slice';
import { useHistorySlice } from '../../../store/slices/history/selectors';
import { historyActions } from '../../../store/slices/history/slice';
import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import { Loader } from '../../loader';
import { HistoryListConnected } from '../list/HistoryListConnected';
import { HistorySingleConnected } from '../single/HistorySingleConnected';

import styles from './HistoryModalContainer.module.css';

export const HistoryModalContainer: FunctionComponent<{ inNavDrawer?: boolean }> = ({ inNavDrawer }) => {
  const dispatch = useCoreDispatch();
  const gameInfo = useHistorySlice.getGameInfo();
  const container = useRef<HTMLDivElement>(null);
  const [scrollTop, setScrollTop] = useState(0);
  const navLevel = useHeaderSlice.getNavRouteLevel();

  useEffect(() => {
    return () => {
      dispatch(historyActions.setGameInfo(null));
    };
  }, [dispatch]);

  useEffect(() => {
    if (gameInfo == null && scrollTop) {
      container.current?.scrollTo(0, scrollTop);
    }
  }, [gameInfo]);

  useEffect(() => {
    if (navLevel <= 2 && inNavDrawer) {
      dispatch(historyActions.setGameInfo(null));
    }
  });

  return (
    <ErrorBoundary fallback={<Loader />}>
      <div data-testid="history-container" className={styles.HistoryModalContainer} ref={container}>
        {gameInfo ? (
          <HistorySingleConnected game={gameInfo} inNavDrawer={inNavDrawer} />
        ) : (
          <HistoryListConnected
            onSelect={(newGameInfo: IHistoryGame): void => {
              setScrollTop(container.current?.scrollTop || 0);
              dispatch(historyActions.setGameInfo(newGameInfo));
              if (inNavDrawer) {
                dispatch(headerActions.pushNavRoute(newGameInfo.gameId.toString()));
              }
            }}
          />
        )}
      </div>
    </ErrorBoundary>
  );
};
